<template>
  <div class="loading" >
		<transition name="fade-loading-screen" v-if="loading && !failedLoading">
			<h1>
				<span class="language de">Exposé wird geladen</span>
				<span class="language es">Cargando exposé</span>
				<span class="language it">Caricamento brochure interattiva</span>
				<span class="language en">Loading property brochure</span>
			</h1>
		</transition>
		<transition name="fade-section" v-else-if="loading && failedLoading">
			<h1>
				<span class="language de">Exposé ist abgelaufen</span>
				<span class="language es">Exposé expirado</span>
				<span class="language it">Brochure interattiva scaduta</span>
				<span class="language en">Property brochure expired</span>
			</h1>
		</transition>
  </div>
</template>

<script>
export default {
	props: {
		loading: {
			type: Boolean
		},
		failedLoading: {
			type: Boolean
		}
	},

	methods: {
		checkLanguage() {
			var userLang = navigator.language; 

			if (userLang.includes('de')) {
				document.querySelector('span.de').style.display = 'block';
				document.querySelector('span.es').style.display = 'none';
				document.querySelector('span.it').style.display = 'none';
				document.querySelector('span.en').style.display = 'none';
			}
			else if (userLang.includes('es')) {
				document.querySelector('span.de').style.display = 'none';
				document.querySelector('span.es').style.display = 'block';
				document.querySelector('span.it').style.display = 'none';
				document.querySelector('span.en').style.display = 'none';
			}
			else if (userLang.includes('it')) {
				document.querySelector('span.de').style.display = 'none';
				document.querySelector('span.es').style.display = 'none';
				document.querySelector('span.it').style.display = 'block';
				document.querySelector('span.en').style.display = 'none';
			}
			else {
				document.querySelector('span.de').style.display = 'none';
				document.querySelector('span.es').style.display = 'none';
				document.querySelector('span.it').style.display = 'none';
				document.querySelector('span.en').style.display = 'block';
			}
		}
	},

	mounted() {
		this.checkLanguage();
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	@import "@/assets/scss/loadingscreenComponent.scss";

	.fade-section-enter-active,
	.fade-loading-screen-leave-active {
		transition: opacity 0.5s ease;
	}

	.fade-section-enter-from,
	.fade-loading-screen-leave-to {
		opacity: 0;
	}

	.fade-section-enter-active {
		transition: opacity 0.5s ease;
		transition-delay: 1.5s;
	}

	.fade-section-enter-from {
		opacity: 0;
	}
</style>
